// extracted by mini-css-extract-plugin
export var errorIcon = "_mb-1";
export var nameLogo = "_mb-0";